import React, { useEffect, useState } from "react";
import { NavLink, Link } from "react-router-dom";
import "./RoleAlignedContent.css";
import AOS from "aos";
import "aos/dist/aos.css";
import HomeNavbarmenu from "../HomeFolder/HomeNavbarmenu";
import HomeSideNavbar from "../HomeFolder/HomeSideNavbar";
function RoleAlignedContent() {
  return (
    <>
      <div className="navbar-holder">
        <HomeNavbarmenu />
      </div>
      <div className="home-sidenavbar-holder">
        <HomeSideNavbar />
      </div>
      <div className="video-container" id="main">
        <title>L-TT Role-Aligned Curriculum</title>
        <h1 class="sr-only" tabIndex={0}>
          Role-Aligned Curriculum
        </h1>
        <img
          src={
            process.env.PUBLIC_URL + "/images/RoleAligned/coming-soon-banner.png"
          }
          alt="about-banner"
          className="banner-img"
        />
        <ul className="breadcrumbs">
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Home"
            >
              L&TT Home
            </NavLink>
            <span>/</span>
          </li>
          <li className="breadcrumbs-item">
            <NavLink
              activeClassName="is-active"
              className="breadcrumbs-links"
              to="/Role-Aligned-Curriculum"
            >
              Role-Aligned Curriculum
            </NavLink>
          </li>
        </ul>
      </div>
    </>
  );
}

export default RoleAlignedContent;
